import { useParams } from 'next/navigation';
import parseLocale from '@/core/i18n/parse-locale';

/**
 * Returns the current locale and its language/country parts from the URL.
 * Use this in client components instead of useLocale() + manual split when you need language or country.
 */
const useLocaleParams = () => {
  const { locale } = useParams();

  // Handle both array and string formats from useParams
  const normalizedLocale = Array.isArray(locale) ? locale[0] : locale;
  const { language, country } = parseLocale(normalizedLocale ?? '');

  return {
    language: language || undefined,
    country: country || undefined,
    locale: normalizedLocale,
  };
};

export default useLocaleParams;
